import {IntegrationsPageLayout} from '../../../_gori/layout/components/IntegrationsPagesLayout'
import {SeoHead} from '../../modules/seo'

export function TemuIntegration() {
  return (
    <>
      <SeoHead />
      <IntegrationsPageLayout
        pageClass='temu-integration'
        integrationLogo='/media/gori/integrations/temu/temu-logo.webp'
        integrationLogoAlt='temu-logo'
        integrateImg='/media/gori/integrations/temu/integrate.webp'
        card1Copy='TEMU_CARD_1'
        card2Copy='TEMU_CARD_2'
        card3Copy='TEMU_CARD_3'
        card4Copy='TEMU_CARD_4'
        store='Temu'
      />
    </>
  )
}
